const isInGame = () => {
  return /bnsingamebrowser|bnsingamebrowser\/f/.test(navigator.userAgent.toLowerCase());
};

export default isInGame;
